<template>
    <div class="becomeAgency-wrapper ba-refresh bas-page">
        <div class="ba-inner bas-inner">
            <span class="ba-badge">Application submitted</span>

            <h1 class="bas-title">Congratulations!</h1>

            <p class="bas-lead">You have become an agent.</p>
            <p class="bas-sub">Go and experience it!</p>

            <span class="bas-rule"></span>

            <p class="bas-note">
                Starmate official BD will contact you on WhatsApp with the next steps.
            </p>
        </div>
    </div>
</template>

<script>
// Shares the Become an Agent page's ground so the two ends of the flow match.
import "./BecomeAgencyRefresh.css";

export default {
    name: "CongratulationsScreen",
};
</script>

<style scoped>
/* The screen used to be a single 302 KB illustration. The words it carried are
   the whole message, so they are set as type now — sharp at any density, and
   they reflow instead of scaling down on a narrow phone. */

.bas-page {
    display: flex;
    align-items: center;
    justify-content: center;
    /* Extra bottom padding lifts the block above the true centre — dead centre
       reads as low on a tall phone. */
    padding-bottom: 12vh;
}

.bas-inner {
    width: 100%;
    text-align: center;
}

.bas-title {
    margin: 16px 0 0;
    /* Fluid so the single longest word still fits one line on a 320px phone. */
    font-size: clamp(31px, 10.4vw, 44px);
    font-weight: 900;
    line-height: 1.05;
    letter-spacing: -0.02em;
    /* Warm-to-white so it lifts off the red ground the way the artwork did. */
    background: linear-gradient(180deg, #FFFFFF 0%, #FFF0C9 55%, #FFD77A 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    text-wrap: balance;
}

.bas-lead {
    margin: 14px 0 0;
    font-size: 17px;
    font-weight: 800;
    line-height: 1.4;
    color: #fff;
    text-wrap: pretty;
}

.bas-sub {
    margin: 6px 0 0;
    font-size: 15px;
    font-weight: 700;
    color: #FFE1A8;
}

.bas-rule {
    display: block;
    width: 54px;
    height: 2px;
    margin: 22px auto 0;
    border-radius: 1px;
    background: rgba(255, 255, 255, 0.42);
}

.bas-note {
    margin: 16px auto 0;
    max-width: 300px;
    font-size: 12.5px;
    font-weight: 600;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.82);
    text-wrap: pretty;
}
</style>
